import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as evenimentsActions from '../../store/actions/evenimentsActions'

const EvenimentDelete = props => {
    const onClick = e => {
        e.preventDefault()

        if(window.confirm('Esti sigur?')) {
            props.evenimentsActions.remove(props.id)
        }
    }

    return (
        <a onClick={onClick}><i className="material-icons">delete_forever</i></a>
    )
}

const mapStateToProps = (state, props) => {
    return {
        eveniments: state.eveniments.eveniments
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        evenimentsActions: bindActionCreators(evenimentsActions, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EvenimentDelete)


// WEBPACK FOOTER //
// ./src/components/eveniments/EvenimentDelete.js